import { useStore } from "@/lib/store";

export default function AboutPage() {
  const { t, language, storeName } = useStore();

  return (
    <div className="max-w-3xl mx-auto px-4 py-12 animate-fade-in">
      <h1 className="font-display text-2xl tracking-wider mb-8">{t("aboutUs")}</h1>

      <div className="space-y-8 text-sm leading-relaxed">
        <div className="space-y-4 text-zinc-300">
          <p>
            {language === "RU"
              ? `${storeName} — магазин одежды с характером. В ассортименте — новые, винтажные и бывшие в употреблении (Б/У) вещи. Состояние каждой позиции честно указано в карточке товара.`
              : `${storeName} is a clothing store with character. Our range includes new, vintage and pre-owned items. The condition of each item is honestly stated in its listing.`}
          </p>
          <p>
            {language === "RU"
              ? "Всегда готовы прислать дополнительные фото, видео и замеры перед покупкой."
              : "We are always happy to send extra photos, videos and measurements before purchase."}
          </p>
        </div>

        <div className="space-y-4">
          <h2 className="font-display text-lg tracking-wider text-white">
            {language === "RU" ? "НАШИ КАНАЛЫ" : "OUR CHANNELS"}
          </h2>

          <div className="space-y-3">
            <a href="https://t.me/Sizzhkaa" target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-between p-4 border border-zinc-800 hover:bg-zinc-900 transition-colors group">
              <div>
                <p className="text-white font-display tracking-wider">
                  {language === "RU" ? "ОСНОВНОЙ КАНАЛ" : "MAIN CHANNEL"}
                </p>
                <p className="text-xs font-mono text-zinc-500 mt-1">@Sizzhkaa</p>
              </div>
              <span className="text-zinc-600 group-hover:text-white transition-colors">→</span>
            </a>

            <a href="https://t.me/hisstorycall" target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-between p-4 border border-zinc-800 hover:bg-zinc-900 transition-colors group">
              <div>
                <p className="text-white font-display tracking-wider">
                  {language === "RU" ? "ВТОРОЙ КАНАЛ" : "SECOND CHANNEL"}
                </p>
                <p className="text-xs font-mono text-zinc-500 mt-1">@hisstorycall</p>
              </div>
              <span className="text-zinc-600 group-hover:text-white transition-colors">→</span>
            </a>

            <a href="https://t.me/inf1rmary" target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-between p-4 border border-zinc-800 hover:bg-zinc-900 transition-colors group">
              <div>
                <p className="text-white font-display tracking-wider">
                  {language === "RU" ? "ПРОВЕРКА / НОВОСТИ" : "VERIFICATION / NEWS"}
                </p>
                <p className="text-xs font-mono text-zinc-500 mt-1">@inf1rmary</p>
              </div>
              <span className="text-zinc-600 group-hover:text-white transition-colors">→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
